export default __webpack_public_path__ + "static/media/Set4_1-min2.9e40b6c7.png";